import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import EventCard from '~/components/EventCard/EventCard';
import LiveNowChip from '~/components/LiveNowChip/LiveNowChip';
import StyledComponent from '~/components/Styled/Styled';
import MiddleDot from '~/constants/MiddleDot';
import css from '~/components/TeamMiniSchedule/TeamMiniSchedule.scss';

const renderTime = gameDate => moment(gameDate).format('ddd MMMM D');

const renderPreviousEvent = event => (
  <div className={css.eventCard}>
    <div className={css.header}>
      <span>PREVIOUS GAME</span>
      <span className={css.middleDot}>{MiddleDot}</span>
      {renderTime(event.game_date)}
    </div>
    <EventCard event={event} />
  </div>
);

const renderUpcomingEvent = event => (
  <div>
    <div className={css.nextGameHeader}>
      <span>NEXT GAME</span>
      <span className={css.middleDot}>{MiddleDot}</span>
      {renderTime(event.game_date)}
    </div>
    <div className={`${css.nextGameBorder} ${css.eventCard}`}>
      <EventCard event={event} />
    </div>
  </div>
);

const renderCurrentEvent = event => (
  <div>
    <div className={css.liveNow}>
      <LiveNowChip />
    </div>
    <div className={css.eventCard}>
      <EventCard event={event} />
    </div>
  </div>
);

class TeamMiniSchedule extends React.PureComponent {
  render() {
    return (
      <div className={`row ${css.container}`}>
        <div className="col-sm-6">
          {!this.props.currentEvent[0] &&
            this.props.previousEvents[0] &&
            renderPreviousEvent(this.props.previousEvents[0])}
          {this.props.currentEvent[0] && renderCurrentEvent(this.props.currentEvent[0])}
        </div>
        <div className="col-sm-6">
          {this.props.upcomingEvents[0] && renderUpcomingEvent(this.props.upcomingEvents[0])}
        </div>
      </div>
    );
  }
}

TeamMiniSchedule.displayName = 'TeamMiniSchedule';

TeamMiniSchedule.propTypes = {
  previousEvents: PropTypes.array.isRequired,
  currentEvent: PropTypes.array.isRequired,
  upcomingEvents: PropTypes.array.isRequired,
};

export default StyledComponent(TeamMiniSchedule, [css]);
